import { EventEmitter } from "events";

const createUUID = () => {
  const pattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  return pattern.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const Constants = {
  CHANGE: "change",
  LOADING: "loading",
  COMPLETE: "complete",
  HIDING: "hiding"
};

class LoadingSnackbarManager extends EventEmitter {
  constructor() {
    super();
    //this.listNotify = [];
    this.notify = {};
  }

  create(notify) {
    const defaultNotify = {
      /// setup default property
      id: createUUID(),
      type: "loading",
      message: null,
      timeOut: 5000
    };

    this.notify = Object.assign(defaultNotify, notify);

    // if (notify.priority) {
    //   this.listNotify.unshift(Object.assign(defaultNotify, notify));
    // } else {
    //   this.listNotify.push(Object.assign(defaultNotify, notify));
    // }

    this.emitChange();
  }

  loading(message, timeOut, onClick) {
    this.create({
      type: Constants.LOADING,
      message,
      timeOut,
      onClick
    });
  }

  complete(message, timeOut, onClick) {
    this.create({
      type: Constants.COMPLETE,
      message,
      timeOut,
      onClick
    });
  }

  hiding(message, timeOut, onClick) {
    this.create({
      type: Constants.HIDING,
      message,
      timeOut,
      onClick
    });
  }

  remove(notification) {
    this.notify = {};
    this.emitChange();
  }

  emitChange() {
    this.emit(Constants.CHANGE, this.notify);
  }

  addChangeListener(callback) {
    this.addListener(Constants.CHANGE, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(Constants.CHANGE, callback);
  }
}

export default new LoadingSnackbarManager();
